"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setDebugStyle = setDebugStyle;
exports.columnWidth = exports.grid = void 0;

var _styledComponents = require("styled-components");

var _colors = require("./colors");

/**
 * Module dependencies.
 */

/**
 * Export `grid` configuration.
 */
var grid = {
  columns: 12,
  containers: {},
  debug: {
    backgroundColor: '#00483b',
    color: '#00ffd0',
    showGrid: false,
    size: 16
  },
  gutter: 16,
  unit: 'px'
};
/**
 * Export `columnWidth`.
 */

exports.grid = grid;

var columnWidth = function columnWidth(columns) {
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : grid.columns;
  return 100 / max * columns;
};
/**
 * Export `setDebugStyle`.
 */


exports.columnWidth = columnWidth;

function setDebugStyle(_ref) {
  var debug = _ref.debug,
      theme = _ref.theme;

  if (!debug) {
    return (0, _styledComponents.css)([""]);
  }

  var grid = theme.grid;
  return (0, _styledComponents.css)(["background-color:", " !important;color:", " !important;", " & *{background-color:", " !important;color:", " !important;outline:1px solid ", " !important;}"], grid.debug.backgroundColor, grid.debug.color, !grid.debug.showGrid ? (0, _styledComponents.css)([""]) : (0, _styledComponents.css)(["background-attachment:fixed;background-image:url('data:image/svg+xml;charset=UTF-8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 ", " ", "\"><rect opacity=\"0.125\" fill=\"none\" stroke=\"", "\" stroke-width=\"2px\" x=\"0\" y=\"0\" width=\"", "\" height=\"", "\" stroke-dasharray=\"", ",", "\" stroke-dashoffset=\"-", "\"/></svg>') !important;background-position:top center !important;background-repeat:repeat !important;background-size:", "", " !important;"], grid.debug.size, grid.debug.size, grid.debug.color, grid.debug.size, grid.debug.size, grid.debug.size * 2, grid.debug.size * 2, grid.debug.size, grid.debug.size, grid.unit), (0, _colors.transparentize)(grid.debug.color, 0.125), grid.debug.color, (0, _colors.transparentize)(grid.debug.color, 0.5));
}